"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const icons_material_1 = require("@mui/icons-material");
const material_1 = require("@mui/material");
const SelectionIndicatorV2_styles_1 = require("./SelectionIndicatorV2.styles");
const SelectionIndicatorV2 = (props) => {
    const { value, onValueChange, min = 0, max = 100, disabled = false, addId, removeId, qaId, elevated = false } = props, rest = __rest(props, ["value", "onValueChange", "min", "max", "disabled", "addId", "removeId", "qaId", "elevated"]);
    const [count, setCount] = (0, react_1.useState)(value || 0);
    const [isExpanded, setIsExpanded] = (0, react_1.useState)(value !== 0 && value !== undefined);
    const styles = (0, SelectionIndicatorV2_styles_1.useSelectionIndicatorStyles)({ elevated, disabled, isExpanded });
    (0, react_1.useEffect)(() => {
        if (value === undefined)
            return;
        if (value < min) {
            setCount(min);
            onValueChange(min, 'remove');
        }
        else if (max > 0 && value > max) {
            setCount(max);
            onValueChange(max, 'add');
        }
        else if (value !== count) {
            setCount(value);
        }
        setIsExpanded(value > 0);
    }, [value, min, max, onValueChange]);
    const addCount = (e) => {
        const newValue = count + 1;
        if (max && newValue > max)
            return;
        setCount(newValue);
        setIsExpanded(true);
        onValueChange(newValue, 'add', e);
    };
    const removeCount = (e) => {
        const newValue = count - 1;
        if (newValue < min)
            return;
        setCount(newValue);
        onValueChange(newValue, 'remove', e);
        if (newValue === 0) {
            setIsExpanded(false);
        }
    };
    return ((0, jsx_runtime_1.jsx)(material_1.Box, Object.assign({}, rest, { sx: styles.wrapper, "data-qa-id": qaId, children: (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: styles.container, children: [isExpanded && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.IconButton, { sx: styles.button, onClick: removeCount, disabled: disabled || count <= min, id: removeId, children: (0, jsx_runtime_1.jsx)(icons_material_1.RemoveRounded, { sx: styles.icon }) }), (0, jsx_runtime_1.jsx)(material_1.Box, { sx: styles.value, children: count })] })), (0, jsx_runtime_1.jsx)(material_1.IconButton, { sx: styles.button, onClick: addCount, disabled: disabled || (max !== undefined && count >= max), id: addId, children: (0, jsx_runtime_1.jsx)(icons_material_1.AddRounded, { sx: styles.icon }) })] }) })));
};
exports.default = SelectionIndicatorV2;
